import { callApi } from '../../utils';
import { SET_CONFIG } from '../constants/config';

const setConfig = config => ({
  type: SET_CONFIG,
  config,
});

const getConfigFromEnv = () => {
  const envKeys = Object.keys(process.env);
  return envKeys
    .filter(key => key.includes('REACT_APP_'))
    .reduce((configSoFar, currentKey) => {
      const config = { ...configSoFar };
      config[currentKey] = process.env[currentKey];
      return config;
    }, {});
};

const getFullConfig = (configFromFile) => {
  const configFromEnv = getConfigFromEnv();
  if (!configFromFile) return configFromEnv;
  return { ...configFromEnv, ...configFromFile };
};

const getConfigUrlByEnv = (env = 'holidays', jsonName = 'bme', dateTime = Date.now()) => `https://${env}.butlins.com/sw/js/${jsonName}.json?timestamp=${dateTime}`;

export const getConfigUrl = (host, dateTime = Date.now()) => {
  if (host.includes('planmydaydev.butlins.com')) return getConfigUrlByEnv('dev', 'bme', dateTime);
  if (host.includes('planmydaytest.butlins.com')) return getConfigUrlByEnv('test', 'bme', dateTime);
  if (host.includes('planmyday.butlins.com')) return getConfigUrlByEnv('holidays', 'bme', dateTime);
  return getConfigUrlByEnv('dev', 'bme', dateTime);
};

const getConfig = () => async (dispatch, getState) => {
  const { currentConfig } = getState();
  if (currentConfig && Object.keys(currentConfig).length > 0) return;
  const { REACT_APP_API_TIMEOUT_MS: timeout, NODE_ENV } = process.env;
  // DEV use the local environments always
  if (NODE_ENV === 'development') {
    dispatch(setConfig(getConfigFromEnv()));
    return;
  }
  const { location = {} } = window || {};
  const { host } = location;
  const configUrl = getConfigUrl(host);
  try {
    const { data: configFromFile } = await callApi({ method: 'get', url: configUrl }, null, null, timeout, true);
    dispatch(setConfig(getFullConfig(configFromFile)));
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.log(error); // eslint-disable-line
    dispatch(setConfig(getConfigFromEnv()));
  }
};

export default getConfig;
